
import { useState, useEffect } from 'react';
import { useOfflineShoppingItems } from '@/hooks/useOfflineShoppingItems';
import { useUserCategories } from '@/hooks/useUserCategories';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';
import OfflineLogger from '@/utils/offlineLogger';

interface OfflineShoppingPageStatusData {
  shoppingItems: any[];
  categories: any[];
}

interface OfflineShoppingPageStatus {
  isOnline: boolean;
  isLoading: boolean;
  hasErrors: boolean;
  pendingOperations: number;
  errors: string[];
  data: OfflineShoppingPageStatusData;
}

export function useOfflineShoppingPageStatus({ listId }: { listId: string }): OfflineShoppingPageStatus {
  const [errors, setErrors] = useState<string[]>([]);
  
  // ✅ FIX: Usa hook esistenti per ottenere dati e status con gestione errori migliorata
  const { 
    shoppingItems, 
    isLoading: itemsLoading, 
    error: itemsError,
    isOnline
  } = useOfflineShoppingItems(listId);
  
  const { 
    data: categories = [], 
    isLoading: categoriesLoading, 
    error: categoriesError 
  } = useUserCategories();
  
  const { 
    pendingOperations, 
    syncErrors 
  } = useOfflineStatus();

  // ✅ FIX: Gestione errori consolidata con logging dettagliato
  useEffect(() => {
    const allErrors: string[] = [];
    
    if (itemsError) {
      const errorMsg = `Errore items: ${itemsError.message || itemsError}`;
      allErrors.push(errorMsg);
      OfflineLogger.error('useOfflineShoppingPageStatus.itemsError', itemsError);
    }
    
    if (categoriesError) {
      const errorMsg = `Errore categorie: ${categoriesError.message || categoriesError}`;
      allErrors.push(errorMsg);
      OfflineLogger.error('useOfflineShoppingPageStatus.categoriesError', categoriesError);
    }
    
    if (syncErrors.length > 0) {
      allErrors.push(...syncErrors);
      OfflineLogger.error('useOfflineShoppingPageStatus.syncErrors', syncErrors);
    }
    
    setErrors(allErrors);
    
    //if (allErrors.length === 0 && (itemsLoading || categoriesLoading)) {
    //  OfflineLogger.info('useOfflineShoppingPageStatus', `Loading: items=${itemsLoading}, categories=${categoriesLoading}`);
    //}

    //if (shoppingItems.length === 0 && !itemsLoading) {
    //  OfflineLogger.info('useOfflineShoppingPageStatus', `No shopping items found for list ${listId}`);
    //}

    //if (categories.length === 0 && !categoriesLoading) {
    //  OfflineLogger.info('useOfflineShoppingPageStatus', 'No categories found');
    //}
  }, [itemsError, categoriesError, syncErrors, itemsLoading, categoriesLoading, shoppingItems.length, categories.length, listId]);

  return {
    isOnline,
    isLoading: itemsLoading || categoriesLoading,
    hasErrors: errors.length > 0,
    pendingOperations,
    errors,
    data: {
      shoppingItems: shoppingItems || [],
      categories: categories || []
    }
  };
}
